function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.125 5.5C6.125 6.53125 6.96875 7.375 8 7.375C9.03125 7.375 9.875 6.53125 9.875 5.5C9.875 4.46875 9.03125 3.625 8 3.625C6.96875 3.625 6.125 4.46875 6.125 5.5ZM11 5.5C11 7.16406 9.66406 8.5 8 8.5C6.33594 8.5 5 7.16406 5 5.5C5 3.83594 6.33594 2.5 8 2.5C9.66406 2.5 11 3.83594 11 5.5ZM3.875 13.75V13.9375C3.875 14.2422 3.61719 14.5 3.3125 14.5C3.00781 14.5 2.75 14.2422 2.75 13.9375V13.75C2.75 11.4766 4.60156 9.625 6.875 9.625H9.125C11.3984 9.625 13.25 11.4766 13.25 13.75V13.9375C13.25 14.2422 12.9922 14.5 12.6875 14.5C12.3828 14.5 12.125 14.2422 12.125 13.9375V13.75C12.125 12.0859 10.7891 10.75 9.125 10.75H6.875C5.21094 10.75 3.875 12.0859 3.875 13.75Z",
  fill: "#006CA3"
});

function SvgIndividualOptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualOptIcon);
export default __webpack_public_path__ + "static/media/individual-opt-icon.8f42e514.svg";
export { ForwardRef as ReactComponent };